import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import { ModalProvider } from '@leroy-merlin-br/backyard-react-ui'
import ReactBreakpoints from 'react-breakpoints'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'

import { Toastify } from 'reactGarden/Toastify'

import { configureStore } from 'lmcv/redux/store'
import { ConfigureInterceptor } from 'lmcv/modules/interceptors'

import { ROUTES, RenderRoutes } from './routes'

ConfigureInterceptor()
dayjs.locale('pt-br')

const breakpoints = {
  mobile: 320,
  mobileLandscape: 480,
  tablet: 768,
  tabletLandscape: 1024,
  desktop: 1200,
  desktopLarge: 1500,
  desktopWide: 1920
}

const store = configureStore()

const App = ({ onLoyaltyProgram, loyaltyProRelationship, loyaltyCouponFeatureFlip }) => {
  localStorage.setItem('@loyalty:token', onLoyaltyProgram)
  localStorage.setItem('@loyalty:proRelationship', loyaltyProRelationship)
  localStorage.setItem('@loyalty:couponFeatureFlip', loyaltyCouponFeatureFlip)

  return (
    <Provider store={store}>
      <ModalProvider>
        <Toastify />
        <ReactBreakpoints breakpoints={breakpoints}>
          <RenderRoutes routes={ROUTES} />
        </ReactBreakpoints>
      </ModalProvider>
    </Provider>
  )
}

App.propTypes = {
  props: PropTypes.shape({
    lmcvDashboard: PropTypes.string,
    onLoyaltyProgram: PropTypes.string.isRequired
  })
}

export default App
